import { motion } from "framer-motion";
import { Rocket, ShieldCheck, Headset } from "lucide-react";
import { useLang } from "./LanguageContext";
import { Reveal } from "./Reveal";

const ICONS = [Rocket, ShieldCheck, Headset];

export const Features = () => {
  const { t } = useLang();

  return (
    <section id="features" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-4">
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#00f0ff]">
              {t.features.overline}
            </span>
            <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight text-white mt-4 leading-tight">
              {t.features.title}
            </h2>
          </Reveal>

          <div className="lg:col-span-8 grid sm:grid-cols-1 gap-5">
            {t.features.items.map((item, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
                  data-testid={`feature-card-${i}`}
                  className="group relative overflow-hidden border border-white/10 bg-white/[0.02] p-8 hover:border-white/25 transition-colors"
                >
                  <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#ccff00]/0 group-hover:bg-[#ccff00]/10 blur-3xl transition-colors duration-500" />
                  <div className="relative flex items-start gap-6">
                    <span className="shrink-0 flex h-14 w-14 items-center justify-center border border-white/15 text-[#ccff00]">
                      <Icon className="h-6 w-6" />
                    </span>
                    <div>
                      <h3 className="font-display font-semibold text-xl md:text-2xl text-white tracking-tight">
                        {item.title}
                      </h3>
                      <p className="mt-2 text-zinc-400 font-light leading-relaxed">{item.desc}</p>
                    </div>
                    <span className="ml-auto font-display font-black text-3xl text-white/5 group-hover:text-white/15 transition-colors">
                      0{i + 1}
                    </span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
